import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-number-column-molecule',
  templateUrl: './number-column-molecule.component.html',
  styleUrls: ['./number-column-molecule.component.scss']
})
export class NumberColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
}
